"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickingWinner = void 0;
const LoadingCircles_1 = __importDefault(require("root/src/client/web/base/LoadingCircles"));
const usePickingWinner_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/usePickingWinner");
const PickingWinner = () => {
    (0, usePickingWinner_1.usePickingWinner)();
    return (<div className="flex flex-col justify-center items-center gap-2">
			<h1 className="font-mono uppercase font-bold">Picking winner</h1>
			<LoadingCircles_1.default width={60} height={60}/>
		</div>);
};
exports.PickingWinner = PickingWinner;
